module.exports = __webpack_public_path__ + "img/Flag_of_Haiti.d2542b64.svg";